import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { DataToDelete } from "src/app/_metronic/core/classes/core.class";

@Injectable()
export class HallTicketService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    generateHallTicket(data) {
        return this.httpClient.post(`${this.apiUrl}/generateHallTicket`, data).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllHallTicket(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllHallTicket/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
   
    public downloadHallTicket() {
        return this.httpClient.get(`${this.apiUrl}/downloadHallTicket`, { responseType: 'blob' })
    }
    
    downloadHallTicketByUser(userId) {
        return this.httpClient.get(`${this.apiUrl}/downloadHallTicketByUser/`+ userId).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
}